import { useAuthStore } from "./store";
import type { UserRole } from "@/types/api";

interface Props {
  roles: UserRole[];
  /** Komponente die gezeigt wird wenn der User die Rolle NICHT hat. Default: null. */
  fallback?: React.ReactNode;
  children: React.ReactNode;
}

/** Render-Guard für rollenbasierte Sichtbarkeit.
 *  Superuser dürfen immer. */
export function RequireRole({ roles, fallback = null, children }: Props) {
  const allowed = useRole(roles);
  if (!allowed) return <>{fallback}</>;
  return <>{children}</>;
}

export function useRole(roles: UserRole[]): boolean {
  const user = useAuthStore((s) => s.user);
  const active = useAuthStore((s) => s.activeTenant());
  if (!user) return false;
  if (user.is_superuser) return true;
  if (!active) return false;
  return roles.includes(active.role);
}
